import { faBagShopping } from '@fortawesome/pro-regular-svg-icons'
import { faClock } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Backdrop } from '@mui/material'
import { Stack, Button, Typography, Box, Tooltip } from '@vapor/material'
import { useTranslation } from 'react-i18next'
import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'
import { useHotelDate } from 'src/app/hooks/context/context.hook'
import useFormatDate from 'src/app/hooks/current-locale/use-format-date'
import { getDayDiff } from 'src/utils/date'

type BuyNowProps = {
  expirationDate: Date
  onClick: () => void
}

export const BuyNow = (props: BuyNowProps) => {
  const { t } = useTranslation()
  const { sm, md } = useBreakpoints()
  const formatDate = useFormatDate()
  const hotelDate = useHotelDate()

  const daysBeforeExpiration = getDayDiff(hotelDate, props.expirationDate)

  const color = daysBeforeExpiration > 5 ? 'var(--DarkImperialBlue)' : daysBeforeExpiration > 1 ? 'orange' : 'red'

  return (
    <>
      <Box //
        sx={{ backgroundColor: 'white', borderRadius: '0px 0px 5px 5px', width: { xs: 38, sm: 220, md: 335 }, height: 38, display: 'block' }}
        className="border-by-now"
        zIndex={(theme) => theme.zIndex.drawer + 2}
      >
        <Stack direction="row" spacing={1} justifyContent={{ xs: 'center', sm: 'space-between' }} alignItems="center" px={1} height={'100%'}>
          <FontAwesomeIcon icon={faClock} color={color} size="xl" className="clock-beat" onClick={props.onClick} />
          {sm && (
            <Tooltip title={daysBeforeExpiration > 0 ? t('pms.trial.expiration_tooltip', { count: daysBeforeExpiration }) : t('pms.trial.expiration_tooltip_expired')}>
              <span>
                <Stack>
                  <Typography variant="caption">{t('pms.trial.trial_version')}</Typography>
                  <Typography variant="caption">{daysBeforeExpiration > 0 ? t('pms.trial.expire_on', { expirationDate: formatDate(props.expirationDate) }) : t('pms.trial.expired')}</Typography>
                </Stack>
              </span>
            </Tooltip>
          )}
          {md && (
            <Button variant="contained" size="small" onClick={props.onClick}>
              <Stack direction="row" spacing={1} alignItems={'center'}>
                <FontAwesomeIcon icon={faBagShopping} />
                <span>{t('pms.trial.buy_now')}</span>
              </Stack>
            </Button>
          )}
          {!md && sm && (
            <Button variant="contained" size="small" onClick={props.onClick}>
              <FontAwesomeIcon icon={faBagShopping} />
            </Button>
          )}
        </Stack>
      </Box>
      <Backdrop sx={{ color: '#fff', backgroundColor: '#000000 !important', zIndex: (theme) => theme.zIndex.drawer + 1, mt: '48px' }} open={daysBeforeExpiration <= 0}>
        <Typography variant="h4">{t('pms.trial.expiration_tooltip_expired')}</Typography>
      </Backdrop>
    </>
  )
}
